import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "TrustedSenders" */ './lazyIndex')
);

export let lazyGetTrustedSendersAndDomains = new LazyAction(
    lazyModule,
    m => m.getTrustedSendersAndDomains
);

export {
    default as isSenderEmailInTrustedSendersOrDomains,
} from './utils/isSenderEmailInTrustedSendersOrDomains';
